/**
 * @author Ketan Shetye
 * @created 2025-11-24
 * @description client admin janus constants
 */

export const clientAdminJanusRoutesNames = {
    root : 'jurisdiction/:clientId',
    workflowApplications : {
        routeName:'workflow-applications',
        name:'Applications'
    },
    renewals :{
        routeName:'renewals',
        name:'Renewals'
    },
    contractors :{
        routeName:'contractors',
        name:'Contractors'
    },
    inspections:{
        routeName:'inspections',
        name:'Inspections'
    },
    reports:{
        routeName:'reports',
        name:'Reports'
    },
    meetings:{
        routeName:'meetings',
        name:'Meetings'
    },
    users:{
        routeName:'users',
        name:'Users'
    },
    settings:{
        routeName:'settings',
        name:'Settings'
    },
    workflows:{
        routeName:'workflows',
        name:'Workflows'
    },
    help:{
        routeName:'help',
        name:'Help'
    }
}